import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { setQuestionsForDoctor as updateQuestionsForDoctor } from '../../redux/userSlice';
import Question from "../../components/Question";
import { textAreaSx } from "../../lib/uiformatting";
import { Box, FormControl, TextField } from "@mui/material";
import ContinueButton from '../../components/ContinueButton';
import setPageAndDeferNavigate from "../../lib/setPageAndDeferNavigate";

export default function QuestionsForDoctor() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const user = useSelector((state) => state.user);
    const [questionsForDoctor, setQuestionsForDoctor] = useState(user.questionsForDoctor);

    const handleNext = () => {
        dispatch(updateQuestionsForDoctor(questionsForDoctor));
        if (user.sex.sexAtBirth === "Female" || user.sex.sexAtBirth === "Prefer not to answer") {
            setPageAndDeferNavigate(dispatch, '/maternity', () =>
                navigate('/maternity', { state: { returning: true } })
            );
        } else {
            setPageAndDeferNavigate(dispatch, '/recent-photo', () =>
                navigate('/recent-photo', { state: { returning: true } })
            );
        }

    };

    const handleBack = () => {
        setPageAndDeferNavigate(dispatch, '/follow-up-care', navigate);
    };

    return (
        <Question
            onBack={handleBack}
            returning={true}
            title="What questions do you have for the doctor?"
            subtitle="No question is too big or too small. Feel free to ask us anything."
            input={
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <FormControl sx={{ width: "100%", mb: "2rem" }} required>
                        <TextField
                            placeholder="Answer here..."
                            variant="outlined"
                            color="secondary"
                            sx={{ ...textAreaSx, width: "100%" }}
                            autoComplete="off"
                            multiline rows={5}
                            value={questionsForDoctor}
                            onChange={(e) => {
                                setQuestionsForDoctor(e.target.value);
                            }}
                        />
                    </FormControl>
                    <ContinueButton
                        onClick={handleNext}
                        title="Continue"
                        disabled={!questionsForDoctor}
                        selected={questionsForDoctor}
                    />
                </Box>
            }
        />
    );
}